module.exports = __webpack_public_path__ + "img/Cheer Megaphone07.8edfd99c.jpg";